module.exports = __webpack_public_path__ + "img/lockIcon.ca28c46a.svg";